import {logger} from '@utils';
import {SagaIterator} from 'redux-saga';
import * as ArticleWebsocket from './article.websocket';

export function* readArticle(action: any): SagaIterator {
  try {
    ArticleWebsocket.readArticle(action.payload);
  } catch (error) {
    logger.info(error);
  }
}



// WEBPACK FOOTER //
// ./src/services/article/article.saga.ts